<!--
 * @Author: cryi.liu
 * @Date: 2020-05-29 10:02:56
 * @LastEditTime: 2020-06-17 10:16:23
 * @Description: 修改试卷操作栏
-->
<template>
  <div class="edit-action-bar">
    <pss-button
      text="删除试卷" @on-click="clickDeletePaperBtnHandler" />
    <pss-button
      text="返回" @on-click="clickCanelBtnHandler" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'EditActionBar',
  props: {
    paperId: { type: [Number, String], required: false },
  },
  computed: {
    ...mapGetters({
      token: 'authStore/token',
    }),
  },
  methods: {
    /**
     * 点击删除试卷按钮处理函数
     */
    async clickDeletePaperBtnHandler() {
      if (window.confirm('确认删除试卷')) {
        const result = await axios.delete(`/examcentersite/paper/${this.paperId}`, { headers: { psstoken: this.token } });

        if (result.data.code === '200') {
          alert('删除成功');
          window.location.href = document.referrer;
        } else {
          alert(result.data.msg);
        }
      }
    },
    /**
     * 点击返回按钮处理函数
     */
    clickCanelBtnHandler() {
      window.location.href = document.referrer;
    },
  },
};
</script>

<style lang="less" scoped>
.edit-action-bar {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  width: 100%;

  > a {
    margin-right: 36px;

    &:last-of-type {
      margin-right: 0;
    }
  }
}
</style>
